// components/PreEmployment/SelectionView.tsx

import React from 'react';
import type { ConstanteData, StatusOption } from '../../../types/preEmployment.types';
import PreEmploymentHeader from './PreEmploymentHeader';
import PatientInfoCard from './PatientInfoCard';
import StatusSelector from './StatusSelector';
import GenerateCertificateButton from './GenerateCertificateButton';

interface SelectionViewProps {
  constanteData: ConstanteData;
  statusOptions: StatusOption[];
  selectedStatus: string;
  onStatusSelect: (statusId: string) => void;
  onGenerateCertificate: () => void;
  onBack: () => void;
}

const SelectionView: React.FC<SelectionViewProps> = ({
  constanteData,
  statusOptions,
  selectedStatus,
  onStatusSelect,
  onGenerateCertificate,
  onBack,
}) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          <PreEmploymentHeader onBack={onBack} />
          
          <PatientInfoCard constanteData={constanteData} />
          
          <StatusSelector
            statusOptions={statusOptions}
            selectedStatus={selectedStatus}
            onStatusSelect={onStatusSelect}
          />
          
          <GenerateCertificateButton
            selectedStatus={selectedStatus}
            onGenerate={onGenerateCertificate}
          />
        </div>
      </div>
    </div>
  );
};

export default SelectionView;